// FinTrack — Dani kasnjenja (upload, parsing, generisanje, filterovanje)
// Napomena: Sav korisnicki unos se eskejpuje pomocu esc() pre renderovanja u DOM

import { state } from './state.js';
import { toast, svgIcon } from './ui.js';
import { fNum, pNum, pDate, validateExcelColumns } from './utils.js';
import { sb } from './supabase.js';
import XLSX from 'xlsx-js-style';

// MODULE-LOCAL STATE
let wbK = null, parsedK = [], kasnFilter = 'all';

// DRAG-DROP INIT
export function initKasnUpzone() {
  const uzK = document.getElementById('upZoneK');
  if (!uzK) return;
  uzK.addEventListener('dragover', e => { e.preventDefault(); uzK.classList.add('dragover'); });
  uzK.addEventListener('dragleave', () => uzK.classList.remove('dragover'));
  uzK.addEventListener('drop', e => { e.preventDefault(); uzK.classList.remove('dragover'); if (e.dataTransfer.files.length) procFileK(e.dataTransfer.files[0]); });
}

// FILE UPLOAD
export function handleFileK(i) { if (i.files.length) procFileK(i.files[0]); }

function procFileK(f) {
  if (!f.name.match(/\.xlsx?$/i)) { toast('Nepodržan format. Koristite .xlsx ili .xls fajl.', 'err'); return; }
  if (wbK && parsedK.length) { toast('Novi fajl učitan — prethodni podaci zamenjeni', 'warn'); }
  const info = document.getElementById('fInfoK');
  info.textContent = '';
  const sp = document.createElement('span'); sp.style.color = 'var(--acc)'; sp.textContent = f.name; info.appendChild(sp);
  const r = new FileReader(); r.onload = e => {
    try {
      wbK = XLSX.read(e.target.result, { type: 'array', cellDates: true });
      const sel = document.getElementById('shSelK'); sel.textContent = '';
      wbK.SheetNames.forEach(s => { const o = document.createElement('option'); o.textContent = s; sel.appendChild(o); });
      parseSheetK();
    } catch (err) { toast('Greška pri čitanju fajla: ' + err.message, 'err'); }
  }; r.readAsArrayBuffer(f);
}

export function parseSheetK() {
  const sn = document.getElementById('shSelK').value; if (!wbK || !sn) return;
  const result = parseSheetDataK(wbK.Sheets[sn]);
  if (!result) return;
  const info = document.getElementById('fInfoK');
  const sp = document.createElement('span'); sp.style.color = 'var(--suc)'; sp.textContent = ' \u2713 ' + parsedK.length + ' kom.'; info.appendChild(sp);
}

// EXCEL PARSING
function parseSheetDataK(sheet) {
  const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: true, defval: null });
  if (rows.length < 2) { toast('Sheet je prazan ili ima samo zaglavlje', 'err'); return false; }
  const hdr = rows[0];

  // Validacija obaveznih kolona
  const missing = validateExcelColumns(hdr, [['komitent'], ['saldo']]);
  if (missing.length) {
    toast('Excel nema očekivane kolone: ' + missing.join(', ') + '. Proverite format fajla.', 'err');
    return false;
  }

  const ci = (names) => { for (const n of names) { const i = hdr.findIndex(h => h && String(h).trim().toLowerCase().includes(n.toLowerCase())); if (i >= 0) return i; } return -1; };
  const C = {
    kom: ci(['komitent']),
    saldo: ci(['saldo']),
    dos: (() => { const i = hdr.findIndex(h => h && /^dospelo$/i.test(String(h).trim())); return i >= 0 ? i : hdr.findIndex(h => h && /(?<!ne)dospelo/i.test(String(h).trim())); })(),
    dug: ci(['duguje', 'dugov']),
    izn: ci(['iznos']),
    ddok: ci(['datum dokumenta', 'datum dok']),
    rok: ci(['rok pla']),
    dk: ci(['dani kaš', 'dani kas']),
    vd: ci(['vrsta dokumenta', 'vrsta dok']),
    bd: ci(['broj dokumenta', 'broj dok'])
  };
  // Precomputed set of known komitent names (lowercase) — for šifra-prefix stripping
  const knownNames = new Set(state.komData.map(k => (k.name || '').toLowerCase()));
  parsedK = []; let cur = null;
  for (let i = 1; i < rows.length; i++) {
    const r = rows[i]; if (!r || r.every(c => c == null || c === '')) continue;
    const kv = C.kom >= 0 ? r[C.kom] : null;
    const sv = C.saldo >= 0 ? r[C.saldo] : null;
    let cl = kv ? String(kv).replace(/\xa0/g, ' ').trim() : '';
    // Strip leading šifra ("28 Elektroprivreda Srbije" → "Elektroprivreda Srbije") only if the stripped form matches a known komitent
    if (cl) { const m = cl.match(/^\d+\s+(.+)$/); if (m && !knownNames.has(cl.toLowerCase()) && knownNames.has(m[1].toLowerCase())) cl = m[1]; }
    if (cl && sv != null && sv !== '') {
      cur = { komitent: cl, saldo: pNum(sv), details: [] }; parsedK.push(cur);
    } else if (cur) {
      const ddok = C.ddok >= 0 ? r[C.ddok] : null;
      const rok = C.rok >= 0 ? r[C.rok] : null;
      const hasBrDok = C.bd >= 0 && r[C.bd] != null && r[C.bd] !== '';
      if (ddok || rok || hasBrDok) {
        const amt = C.dos >= 0 ? pNum(r[C.dos]) : 0;
        cur.details.push({
          ddok: ddok ? String(ddok).trim() : '',
          rok: rok ? String(rok).trim() : '',
          dos: amt,
          dk: C.dk >= 0 ? pNum(r[C.dk]) : 0,
          vd: C.vd >= 0 && r[C.vd] ? String(r[C.vd]).trim() : '',
          bd: C.bd >= 0 && r[C.bd] ? String(r[C.bd]).trim() : ''
        });
      }
    }
  }

  const totalDataRows = rows.length - 1;
  const parsedDetails = parsedK.reduce((s, k) => s + k.details.length, 0);
  if (!parsedK.length) { toast('Nije pronađen nijedan komitent u odabranom sheet-u', 'err'); return false; }
  const skipped = totalDataRows - parsedK.length - parsedDetails;
  if (skipped > 0) {
    const info = document.getElementById('fInfoK');
    const sp = document.createElement('span'); sp.style.cssText = 'color:var(--warn);margin-left:8px'; sp.textContent = '(' + skipped + ' redova preskočeno)'; info.appendChild(sp);
  }
  return true;
}

// GENERATION
export function genKasn() {
  if (!parsedK.length) { toast('Učitajte Excel fajl', 'err'); return; }
  const from = pDate(document.getElementById('dtFromK').value), to = pDate(document.getElementById('dtToK').value);
  if (!from || !to) { toast('Unesite oba datuma', 'err'); return; }
  if (from > to) { toast('Datum "Od" mora biti pre datuma "Do"', 'err'); return; }
  const komMap = {}; for (const k of state.komData) { const vr = state.vrsteData.find(v => v.id === k.vrsta_troska_id); if (vr) komMap[k.name] = vr; }
  state.kasnInvoices = [];
  for (const k of parsedK) {
    for (const d of k.details) {
      const filterDate = d.ddok || d.rok;
      if (!filterDate) continue;
      const fd = pDate(filterDate);
      if (!fd || fd < from || fd > to) continue;
      state.kasnInvoices.push({ komitent: k.komitent, ddok: d.ddok || '\u2014', rok: d.rok || '\u2014', dos: d.dos, dk: d.dk, vd: d.vd, bd: d.bd, vrsta: komMap[k.komitent] || null });
    }
  }
  state.kasnInvoices.sort((a, b) => b.dk - a.dk);

  if (!state.kasnInvoices.length) { toast('Nema računa za izabrani period', 'err'); return; }

  const total = state.kasnInvoices.length;
  const late90 = state.kasnInvoices.filter(r => r.dk >= 90).length;
  const late60 = state.kasnInvoices.filter(r => r.dk >= 60 && r.dk < 90).length;
  const late30 = state.kasnInvoices.filter(r => r.dk >= 30 && r.dk < 60).length;
  const ok = state.kasnInvoices.filter(r => r.dk <= 0).length;
  const totalLateRsd = state.kasnInvoices.filter(r => r.dk > 0).reduce((s, r) => s + r.dos, 0);
  document.getElementById('kStats').style.display = 'block';
  document.getElementById('kFilters').style.display = 'flex';
  const bar = document.getElementById('kStBar');
  bar.textContent = '';
  [
    { l: 'Ukupno ra\u010duna', v: total },
    { l: '90+ dana', v: late90, c: 'var(--dng)', bc: 'rgba(255,92,106,.2)' },
    { l: '60-89 dana', v: late60, c: '#ff8c42', bc: 'rgba(255,140,66,.2)' },
    { l: '30-59 dana', v: late30, c: 'var(--warn)', bc: 'rgba(255,181,71,.2)' },
    { l: 'U roku', v: ok, c: 'var(--suc)', bc: 'rgba(0,232,157,.2)' },
    { l: 'Dospelo (kasne)', v: fNum(totalLateRsd), c: 'var(--dng)', fs: '14px' }
  ].forEach(s => {
    const d = document.createElement('div'); d.className = 'sti'; if (s.bc) d.style.borderColor = s.bc;
    const sl = document.createElement('div'); sl.className = 'stl'; sl.textContent = s.l;
    const sv = document.createElement('div'); sv.className = 'stv'; sv.textContent = s.v; if (s.c) sv.style.color = s.c; if (s.fs) sv.style.fontSize = s.fs;
    d.appendChild(sl); d.appendChild(sv); bar.appendChild(d);
  });
  filterKasn('all');
}

// FILTERING & RENDERING — uses DOM API for XSS safety
export function filterKasn(f) {
  kasnFilter = f;
  document.querySelectorAll('.kfb').forEach(b => b.classList.remove('active'));
  const fb = document.getElementById('kf-' + f); if (fb) fb.classList.add('active');
  let filtered = state.kasnInvoices;
  if (f === '90') filtered = state.kasnInvoices.filter(r => r.dk >= 90);
  else if (f === '60') filtered = state.kasnInvoices.filter(r => r.dk >= 60);
  else if (f === '30') filtered = state.kasnInvoices.filter(r => r.dk >= 30);
  else if (f === 'ok') filtered = state.kasnInvoices.filter(r => r.dk <= 0);
  const maxDk = state.kasnInvoices.length ? Math.max(...state.kasnInvoices.map(r => Math.abs(r.dk)), 1) : 1;

  const kOut = document.getElementById('kOut');
  kOut.textContent = '';

  if (!filtered.length) {
    const empty = document.createElement('div'); empty.className = 'card'; empty.style.cssText = 'text-align:center;padding:30px;color:var(--tx3)';
    empty.textContent = 'Nema ra\u010duna u ovom filteru'; kOut.appendChild(empty); return;
  }

  const card = document.createElement('div'); card.className = 'card'; card.style.cssText = 'padding:0;overflow:hidden';

  // Header row
  const hdrRow = document.createElement('div');
  hdrRow.style.cssText = 'display:grid;grid-template-columns:45px 1fr 130px 130px 130px 110px 90px;padding:10px 16px;font-family:var(--dp);font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:1px;color:var(--tx3);border-bottom:1px solid var(--border);background:rgba(22,23,31,.5);gap:8px';
  ['#', 'Komitent', 'Datum dok.', 'Rok pla\u0107anja', 'Dospelo (RSD)', 'Ka\u0161njenje', 'Dok.'].forEach((t, i) => {
    const d = document.createElement('div'); d.textContent = t;
    if (i === 0) d.style.textAlign = 'center';
    if (i === 4) d.style.textAlign = 'right';
    if (i === 5) d.style.textAlign = 'center';
    hdrRow.appendChild(d);
  });
  card.appendChild(hdrRow);

  filtered.forEach((r, i) => {
    const pct = Math.min(Math.abs(r.dk) / maxDk * 100, 100);
    let clr = 'var(--suc)', bg = 'var(--suc-bg)';
    if (r.dk >= 90) { clr = 'var(--dng)'; bg = 'rgba(255,92,106,.12)'; }
    else if (r.dk >= 60) { clr = '#ff8c42'; bg = 'rgba(255,140,66,.1)'; }
    else if (r.dk >= 30) { clr = 'var(--warn)'; bg = 'rgba(255,181,71,.1)'; }
    else if (r.dk > 0) { clr = '#ffaa5c'; bg = 'rgba(255,170,92,.08)'; }
    const rank = i + 1; const isTop = rank <= 3 && r.dk > 0;

    const row = document.createElement('div');
    row.style.cssText = 'display:grid;grid-template-columns:45px 1fr 130px 130px 130px 110px 90px;align-items:center;padding:12px 16px;border-bottom:1px solid var(--border-lt);transition:var(--tr);gap:8px';
    row.onmouseover = function () { this.style.background = 'var(--hover)'; };
    row.onmouseout = function () { this.style.background = 'transparent'; };

    // #
    const c1 = document.createElement('div'); c1.className = 'k-rank' + (isTop ? ' top3' : ''); if (isTop) c1.appendChild(svgIcon('fire', 14)); c1.appendChild(document.createTextNode(rank));

    // Komitent
    const c2 = document.createElement('div');
    const c2name = document.createElement('div'); c2name.style.cssText = 'font-size:13px;font-weight:500'; c2name.textContent = r.komitent;
    const c2cat = document.createElement('div');
    if (r.vrsta) { c2cat.style.cssText = 'font-size:11px;color:var(--tx3)'; c2cat.textContent = r.vrsta.icon + ' ' + r.vrsta.name_en; }
    else { c2cat.style.cssText = 'font-size:11px;color:var(--warn)'; c2cat.textContent = 'Nekategorisan'; }
    const c2bar = document.createElement('div'); c2bar.className = 'k-bar';
    const c2fill = document.createElement('div'); c2fill.className = 'k-bar-fill'; c2fill.style.cssText = 'width:' + pct + '%;background:' + clr;
    c2bar.appendChild(c2fill); c2.appendChild(c2name); c2.appendChild(c2cat); c2.appendChild(c2bar);

    // Datum dok
    const c3 = document.createElement('div'); c3.style.cssText = 'font-size:12px;color:var(--tx2)'; c3.textContent = r.ddok;

    // Rok
    const c4 = document.createElement('div'); c4.style.cssText = 'font-size:12px;color:var(--tx3)'; c4.textContent = r.rok;

    // Dospelo
    const c5 = document.createElement('div'); c5.style.cssText = 'text-align:right;font-family:var(--mn);font-size:13px;font-weight:600;color:' + (r.dos > 0 ? 'var(--dng)' : 'var(--tx3)'); c5.textContent = fNum(r.dos);

    // Kasnjenje
    const c6 = document.createElement('div'); c6.style.textAlign = 'center';
    const badge = document.createElement('span'); badge.style.cssText = 'display:inline-block;padding:4px 10px;border-radius:14px;font-family:var(--mn);font-size:12px;font-weight:700;background:' + bg + ';color:' + clr;
    badge.textContent = r.dk > 0 ? r.dk + 'd' : r.dk < 0 ? Math.abs(r.dk) + 'd avans' : 'U roku';
    c6.appendChild(badge);

    // Dok
    const c7 = document.createElement('div'); c7.style.cssText = 'font-size:11px;color:var(--tx3)'; c7.textContent = (r.vd || '') + (r.bd ? ' #' + r.bd : '');

    row.appendChild(c1); row.appendChild(c2); row.appendChild(c3); row.appendChild(c4); row.appendChild(c5); row.appendChild(c6); row.appendChild(c7);
    card.appendChild(row);
  });

  kOut.appendChild(card);
}

// KASNJENJA EXCEL EXPORT
export function expKasnXlsx() {
  if (!state.kasnInvoices.length) return;
  const wb = XLSX.utils.book_new();
  function borderAll(c) { const b = { style: 'thin', color: { rgb: c } }; return { top: b, bottom: b, left: b, right: b }; }
  const stH = { font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 }, fill: { fgColor: { rgb: '0F1923' } }, alignment: { horizontal: 'center' }, border: borderAll('CCCCCC') };
  const stN = { font: { sz: 10 }, border: borderAll('E2E8F0') };
  const stNm = { ...stN, alignment: { horizontal: 'right' }, numFmt: '#,##0.00' };
  const stDng = { ...stN, font: { sz: 10, bold: true, color: { rgb: 'FF0000' } }, alignment: { horizontal: 'center' } };
  const stWrn = { ...stN, font: { sz: 10, bold: true, color: { rgb: 'FF8C00' } }, alignment: { horizontal: 'center' } };
  const stOk = { ...stN, font: { sz: 10, color: { rgb: '00AA00' } }, alignment: { horizontal: 'center' } };
  function cs(v, s) { return { v, s, t: typeof v === 'number' ? 'n' : 's' }; }
  const data = [];
  data.push(['#', 'Komitent', 'Kategorija', 'Datum dokumenta', 'Rok pla\u0107anja', 'Dospelo RSD', 'Dani ka\u0161njenja', 'Dokument'].map(h => cs(h, stH)));
  state.kasnInvoices.forEach((r, i) => {
    const dkStyle = r.dk >= 60 ? stDng : r.dk >= 30 ? stWrn : stOk;
    data.push([cs(i + 1, { ...stN, alignment: { horizontal: 'center' } }), cs(r.komitent, stN), cs(r.vrsta ? r.vrsta.name_en : 'Nekategorisan', stN), cs(r.ddok || '', stN), cs(r.rok || '', stN), cs(r.dos, stNm), cs(r.dk, dkStyle), cs((r.vd || '') + (r.bd ? ' #' + r.bd : ''), stN)]);
  });
  const ws = XLSX.utils.aoa_to_sheet(data.map(r => r.map(c => c.v)));
  ws['!cols'] = [{ wch: 6 }, { wch: 38 }, { wch: 22 }, { wch: 14 }, { wch: 14 }, { wch: 16 }, { wch: 14 }, { wch: 18 }];
  data.forEach((row, ri) => { row.forEach((cell, ci) => { const addr = XLSX.utils.encode_cell({ r: ri, c: ci }); if (!ws[addr]) ws[addr] = { v: cell.v, t: cell.t || 's' }; ws[addr].s = cell.s; }); });
  XLSX.utils.book_append_sheet(wb, ws, 'Dani ka\u0161njenja');
  XLSX.writeFile(wb, 'dani_kasnjenja.xlsx', { bookSST: false, cellStyles: true });
  if (state.CU) sb.rpc('log_audit', { p_user_id: state.CU.id, p_action: 'export_excel', p_entity_type: 'kasnjenja', p_entity_name: 'dani_kasnjenja.xlsx' }).then(null, e => console.error('SBIS:', e));
  toast('Excel eksportovan');
}

// ============================================================
// SAVE TO DB — čuva kasnjenja izveštaj sa detaljnim podacima
// ============================================================
export async function saveKasnToDb() {
  if (!state.kasnInvoices || !state.kasnInvoices.length) { toast('Generišite izveštaj prvo', 'err'); return; }
  if (!state.CU) { toast('Niste prijavljeni', 'err'); return; }

  const btn = document.querySelector('button[onclick="saveKasnToDb()"]');
  if (btn) btn.disabled = true;

  const fromK = pDate(document.getElementById('dtFromK').value);
  const toK = pDate(document.getElementById('dtToK').value);
  const totalRsd = state.kasnInvoices.reduce((s, r) => s + r.dos, 0);

  // Build details JSON
  const detailsJson = state.kasnInvoices.map(r => ({
    komitent: r.komitent,
    dos: r.dos,
    dk: r.dk,
    rok: r.rok,
    ddok: r.ddok,
    vrsta: r.vrsta ? r.vrsta.name_en : null,
    vrsta_sr: r.vrsta ? r.vrsta.name_sr : null,
    bd: r.bd || null
  }));

  try {
    // Build Excel for download
    const { buildExcelBase64 } = await import('./history.js');
    const result = buildExcelBase64('kasnjenja');

    const { error } = await sb.rpc('save_report', {
      p_user_id: state.CU.id, p_type: 'kasnjenja',
      p_from: fromK ? fromK.toISOString().slice(0, 10) : '2025-01-01',
      p_to: toK ? toK.toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
      p_rsd: totalRsd, p_usd: 0, p_kurs: 0,
      p_filename: result ? result.fn : 'dani_kasnjenja.xlsx',
      p_base64: result ? result.b64 : '',
      p_details: detailsJson
    });
    if (error) throw error;
    toast('Izveštaj dani kašnjenja sačuvan');
  } catch (e) { toast('Greška: ' + (e.message || e), 'err'); }
  if (btn) btn.disabled = false;
}
